import { useReduxState } from "SubjectStandardsV2/hooks";
import useConfigureColumns from "Hooks/useConfigureColumns";
import { getCurriculumIdAndType } from "SubjectStandardsV2/modules/reduxSelectors";

const useStandardsConfigureColumns = ({ moduleName = "COMMON", ...props }) => {
  const { currentCurriculumProgramId } = useReduxState(getCurriculumIdAndType);
  const dashboardName = currentCurriculumProgramId
    ? `${moduleName}_${currentCurriculumProgramId}`
    : moduleName;

  return useConfigureColumns({ dashboardName, ...props });
};

export default useStandardsConfigureColumns;
